import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

function Empty() {
    return (
        <div className={classes.Empty}>
            <div className={classes.EmptyText}>
                <FormattedMessage id="EventsWidget.empty.message" defaultMessage="Здесь будут важные уведомления"/>
            </div>
        </div>
    );
}

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/EventsWidget/Empty.js